import React, { useEffect, useState } from 'react'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import StateSelectFormField from '../inputs/StateSelectFormField'
import RegisteredFormField from '../../../common/RegisteredFormField'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { US_STATES } from '../../../../constant/US_STATES'
import REQUEST_STATUS from '../../../../state/common/REQUEST_STATUS'
import SuggestedAddressModal from './SuggestedAddressModal'
import { validateCode1Address } from '../../../../state/reducers/validateCode1Address'
import Loader from '../../../common/Loader'

export default function AddressFields ({ rootPath, withSecondaryAddressLine = false }) {
  const dispatch = useDispatch()
  const address = useSelector(state => _.get(state.form, `${rootPath}.address`))
  const [enteredAddressParts, setEnteredAddressParts] = useState({})

  useEffect(() => {
    const { code1validated, suggested, include, ...addressParts } = address
    if (!_.isEqual(addressParts, enteredAddressParts)) {
      setEnteredAddressParts(addressParts)
    }
  }, [address, dispatch, rootPath, enteredAddressParts])

  useEffect(() => {
    if (!address.code1validated.valid &&
      !_.isEmpty(enteredAddressParts) &&
      enteredAddressParts.zip.value.length >= 5 &&
      Object.keys(enteredAddressParts).every(k => enteredAddressParts[k].valid &&
        address.suggested.requestStatus !== REQUEST_STATUS.IN_PROGRESS)
    ) {
      const addressPayload = Object.keys(enteredAddressParts).reduce((o, k) => {
        return {
          ...o,
          [k]: enteredAddressParts[k].value
        }
      }, {})
      dispatch(validateCode1Address({
        path: `${rootPath}.address.suggested`,
        address: {
          ...addressPayload,
          state: {
            abbreviation: addressPayload.state,
            name: US_STATES.filter(s => s.value === addressPayload.state)[0].text
          }
        }
      }))
    }
    // eslint-disable-next-line
  }, [enteredAddressParts, dispatch, rootPath])

  const suggest = !address.code1validated.valid && address.suggested.requestStatus === REQUEST_STATUS.SUCCEEDED

  const className = [
    suggest && 'address--validation required',
    address.suggested.requestStatus === REQUEST_STATUS.IN_PROGRESS && 'Dimmed'
  ].filter(Boolean).join(' ')

  return <Grid container stackable className='height-full'>
    {address.suggested.requestStatus === REQUEST_STATUS.IN_PROGRESS && <Loader className='u-mT10' />}
    <GridRow className={className}>
      {suggest && <GridColumn data-testid='suggested-address' width={16} className='suggested--address required u-pA2'>
        <h6 className='u-mY0'>A <i><b>recommended address</b></i> was found.&nbsp;</h6>
        <SuggestedAddressModal
          key='modal'
          rootPath={`${rootPath}.address`}
          addressObject={address}
        />
      </GridColumn>
      }
      <GridColumn width={16}>
        <RegisteredFormField
          path={`${rootPath}.address.street`}
          id='streetAddressLineOne'
          label='Street Address 1'
        />
      </GridColumn>
      {withSecondaryAddressLine && <GridColumn width={16}>
        <RegisteredFormField
          path={`${rootPath}.address.street2`}
          id='streetAddressLineTwo'
          label='Apt/Suite/Unit/PO Box Number'
        />
      </GridColumn>}
      <GridColumn computer={6}>
        <RegisteredFormField
          path={`${rootPath}.address.city`}
          id='city'
          label='City'
        />
      </GridColumn>
      <GridColumn computer={5}>
        <StateSelectFormField
          path={`${rootPath}.address.state`}
          id='state'
          label='State'
        />
      </GridColumn>
      <GridColumn computer={5}>
        <RegisteredFormField
          path={`${rootPath}.address.zip`}
          id='zip'
          label='Zip Code'
        />
      </GridColumn>
    </GridRow>
  </Grid>
}